import { render, staticRenderFns } from "./LoanableForm.vue?vue&type=template&id=778b1a9c&scoped=true&"
import script from "./LoanableForm.vue?vue&type=script&lang=js&"
export * from "./LoanableForm.vue?vue&type=script&lang=js&"
import style0 from "./LoanableForm.vue?vue&type=style&index=0&id=778b1a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b1a9c",
  null
  
)

export default component.exports